// generated from 52_498 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const internalWorkflowStepRetargetFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("internal_workflow_step_retarget_filter"),
  comparison_key: z.enum([
    "7", // 29_457 (56.11%)
    "8", // 23_041 (43.89%)
  ]),
  display_name: z.enum([
    "opened email", // 21_298 (40.57%)
    "clicked email", // 11_621 (22.14%)
    "directly opened push notification", // 6_162 (11.74%)
    "opened email (other opens)", // 2_925 (5.57%)
    "clicked in-app message", // 2_363 (4.50%)
    "dismissed content card", // 2_189 (4.17%)
    "clicked in-app message button 1", // 1_871 (3.56%)
    "clicked content card", // 1_500 (2.86%)
    "viewed in-app message", // 1_306 (2.49%)
    "viewed content card", // 465 (0.89%)
    "clicked in-app message button 2", // 436 (0.83%)
    "opened email (machine opens)", // 259 (0.49%)
    "read WhatsApp message", // 99 (0.19%)
    "clicked tracked WhatsApp link", // 4 (0.01%)
    // Not sampled, but offered by InternalWorkflowStepRetargetFilter.allowed_interactions
    // (feature flipper dependent; names from TRIGGER_ONLY_PAST_TENSE_DISPLAY_NAME_BY_INTERACTION).
    "viewed banner",
    "clicked banner",
    "dismissed banner",
    "clicked tracked LINE link",
    "clicked tracked KakaoTalk link",
  ]),
  // undefined: 21_103 (40.20%), defined 31_395 (59.80%)
  // null: 2 (0.01%)
  // format object-id: 31_390 (99.99%)
  raw_value: z.string().nullable().optional(),
  value: z.object({
    // null: 2 (0.00%)
    // format object-id: 52_493 (99.99%)
    id: z.string().nullable(),
    // undefined: 52_471 (99.95%), defined 27 (0.05%)
    name: z.string().optional(),
    // undefined: 27 (0.05%), defined 52_471 (99.95%)
    value: z.string().optional(),
  }),
  varies_by_app_group: z.literal(true),
});
